import { Alert, CircularProgress, Grid } from "@mui/material";
import { memo } from "react";
import { API_QUOTES } from "../context/ApiEndPoints";
import useFetchList from "../hooks/useFetchList";

function JobStatus(props) {
  const { records, isLoading, fetchError } = useFetchList(
    `${API_QUOTES}/Compact/${props.quoteId}`,
  );

  const stageStr = (int) => {
    switch (int) {
      case 1:
        return "Job";
      case 2:
        return "Design";
      case 3:
        return "Installation";
      case 4:
        return "Invoice";
      default:
        return "Job";
    }
  };

  const statusToStage = (int) => {
    switch (int) {
      case "Request":
      case "Sent":
      case "Approved":
      case "Billable":
      case "Lost":
        return "Quote";

      case "Invoiced":
      case "Paid":
      case "Waiver":
        return "Invoice";

      default:
        return "Quote";
    }
  };

  const alertStatus = (status) => {
    switch (status) {
      case "Request":
      case "Todo":
      case "Billable":
        return "warning";

      case "Sent":
      case "Waiting":
      case "Invoiced":
        return "info";

      case "Approved":
      case "Completed":
      case "Paid":
        return "success";

      case "Booked":
      case "Lost":
      case "Waiver":
        return "error";

      default:
        return "info";
    }
  };

  return (
    <>
      {fetchError ||
        (isLoading && (
          <CircularProgress size={20} color="inherit" sx={{ m: 3 }} />
        ))}
      {records && (
        <Grid container alignItems="center">
          <Grid item xs={6}>
            <Alert variant="outlined" severity={alertStatus(records.status)}>
              <b>{stageStr(records.stage)}: </b>
              {records.status}
            </Alert>
          </Grid>
          <Grid item xs={6}>
            <Alert severity={alertStatus(records.invoiceStatus)}>
              <b>{statusToStage(records.invoiceStatus)}: </b>
              {records.invoiceStatus}
            </Alert>
          </Grid>
        </Grid>
      )}
    </>
  );
}

export default memo(JobStatus);
